define.alias("shared/components/shared/platform-notice", "preview-grid/components/shared/platform-notice");